<template>
    <div
        class="brush-stroke-bg inline-flex items-center justify-center text-center bg-cover bg-center bg-no-repeat leading-none px-6"
        :style="bgStyle"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "brush-stroke-bg",

    props: {
        variant: {
            type: Number,
            default: 1
        }
    },

    computed: {
        bgStyle() {
            let variants = ["brush-01.svg", "brocha.svg"];

            let bg = require(`@/assets/img/${variants[this.variant - 1]}`);

            return {
                backgroundImage: `url('${bg}')`
            };
        }
    }
};
</script>

<style scoped>
.brush-stroke-bg {
    min-width: 160px;
    min-height: 45px;
    z-index: 2;
    position: relative;
}
</style>
